import { createContext, RefObject } from 'react';
import { Layout } from '../constants';

export interface TabsContextType {
  activeTabId?: number | string;
  isVertical?: boolean;
  layout?: Layout;
  setActiveTabRef?: (node: RefObject<HTMLDivElement> | null) => void;
  variant: 'solid' | 'thin';
}

export const TabsContext = createContext<TabsContextType>({
  activeTabId: undefined,
  isVertical: undefined,
  setActiveTabRef: undefined,
  layout: undefined,
  variant: 'solid',
});
